import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';

import { LinkedInSignInButton } from '../../atoms/linkedInSignInButton';
import { GoogleSignInButton } from '../../atoms/googleSignInButton';

export const SocialOAuthButtons = ({ mode, params, onSuccess, onError, ...props }) => (
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Flex flexDirection="column" sx={{ gap: '8px' }} {...props}>
      <LinkedInSignInButton mode={mode} params={params} onSuccess={onSuccess} onError={onError} />
      <GoogleSignInButton mode={mode} params={params} onSuccess={onSuccess} onError={onError} />
    </Flex>
  </GoogleOAuthProvider>
);

SocialOAuthButtons.propTypes = {
  mode: PropTypes.oneOf(['sign-in', 'sign-up']),
  params: PropTypes.object,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

SocialOAuthButtons.defaultProps = {
  mode: 'sign-in',
  params: {},
  onSuccess: null,
  onError: null,
};
